import {useState} from 'react'
import {coverageMemberOptions,matchesCoverageMember} from '../../lib/schoolTeamOverlay.js'
import SchoolTeamCoverage from './SchoolTeamCoverage.jsx'
import styles from './repVolume.module.css'

export default function SchoolTeamBook({coverage}) {
  const [person,setPerson] = useState('')
  if (!coverage) return <p className={styles.deskWhy}>School-team coverage has not been reported for these assignments.</p>
  if (coverage.status !== 'ready') return <p className={styles.deskBad} role="status">School-team coverage is unavailable. This does not mean there are no assignments.</p>
  const companies = (coverage.companies || []).map(value => ({schoolTeamCoverage:value}))
  const unlinked = (coverage.unlinked || []).map(value => ({schoolTeamCoverage:value}))
  const people = coverageMemberOptions(companies)
  const rows = [...companies,...unlinked].filter(record => matchesCoverageMember(record,person))
  const unresolved = [...companies,...unlinked].filter(record => record.schoolTeamCoverage.status !== 'linked')
  return <section className={styles.wrap} aria-label="School-team coverage summary">
    <h2 className={styles.h}>School-team coverage summary</h2>
    <p className={styles.muted}>These school teams are shown separately from CRM assignments. A company is listed once; team membership does not grant account tools.</p>
    <label className={styles.pickLabel}>Bowl coverage person
      <select value={person} onChange={event => setPerson(event.target.value)}>
        <option value="">All returned school-team coverage</option>
        {people.map(member => <option key={member.id} value={member.id}>{member.name} ({member.role})</option>)}
      </select>
    </label>
    <p className={styles.muted}>{rows.length} returned coverage records{person ? ' match this member' : ''}. Missing links and conflicts are visible in the unfiltered view.</p>
    {person && unresolved.length > 0 && <div role="status">
      <p className={styles.deskBad}>{unresolved.length} coverage records need review and are excluded from confirmed member counts. Their recorded teams remain visible below.</p>
      {unresolved.map((record,index) => <SchoolTeamCoverage key={index} record={record}/>)}
    </div>}
    {rows.map((record,index) => <div key={`${record.schoolTeamCoverage.companyId || 'unlinked'}:${index}`}>
      {record.schoolTeamCoverage.companyId && <p className={styles.deskWhy}>Company ID: {record.schoolTeamCoverage.companyId}</p>}
      <SchoolTeamCoverage record={record}/>
    </div>)}
  </section>
}
